<div class="action-form">
  <span class="title">{{ 'COMMON.COMPANY' | translate }}</span>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row form-group">
        <div class="col-12">
          <app-autocomplete-remote-paged
            [control]="form.controls['destinationCompanyId']"
            [service]="companyService"
            [defaultSearch]="'*'"
          ></app-autocomplete-remote-paged>
          @if (hasBankAccount === true) {
            <div class="row move-to-company-info">
              <div class="col-12">
                <app-information-block [text]="'PROPERTY.MOVE_TO_COMPANY_INFO' | translate"></app-information-block>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-active" type="submit">{{ 'SAVE_BTN' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
